// UserPrivateRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const UserPrivateRoute = () => {
  const token = localStorage.getItem("userId"); // or whatever you're using

  return token ? <Outlet /> : <Navigate to="/userLogin" replace />;
};

export default UserPrivateRoute;
